import FullPageLoading from '@/components/FullPageLoading';
import { VALIDATE_REQUIRED } from '@/config';
import { Form, Input, Row, Col, Checkbox, Button, InputNumber, message } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SaveOutlined } from '@ant-design/icons';
import { PasswordPolicyDto } from '@/__generated';
import { apiSdk } from '@/httpClient';

export default function PasswordConfiguration() {
  const [loading, setLoading] = React.useState<boolean>(true);
  const [passwordPolicy, setPasswordPolicy] = React.useState<PasswordPolicyDto>();
  React.useMemo(() => {
    apiSdk.PasswordPolicyService.getPasswordPolicy()
      .then(res => {
        setPasswordPolicy(res);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  const { t } = useTranslation();
  const save = values => {
    apiSdk.PasswordPolicyService.update({ body: values }).then(res => {
      if (res.success) {
        message.success(t('accessControlPage_UpdateSucessMessage'));
      } else {
        message.error(t(res.message || ''));
      }
    });
  };

  if (loading) {
    return <FullPageLoading loading={true} />;
  }
  return (
    <div style={{ maxWidth: 500 }}>
      <Form onFinish={save} size="middle" layout="vertical" initialValues={passwordPolicy}>
        <Form.Item name="id" className="hidden">
          <Input type="hidden" />
        </Form.Item>
        <Row gutter={6}>
          <Col md={24}>
            <Form.Item label={t('accessControlPage_PasswordLength')} name="passwordLength" rules={[{ required: true, message: VALIDATE_REQUIRED }]}>
              <InputNumber className="w-100" />
            </Form.Item>
            <Form.Item label={t('accessControlPage_NoOfUpperCase')} name="noOfUpperCase" rules={[{ required: true, message: VALIDATE_REQUIRED }]}>
              <InputNumber className="w-100" />
            </Form.Item>
            <Form.Item label={t('accessControlPage_NoOfLowerCase')} name="noOfLowerCase" rules={[{ required: true, message: VALIDATE_REQUIRED }]}>
              <InputNumber className="w-100" />
            </Form.Item>
            <Form.Item
              label={t('accessControlPage_NoOfSpecialCharacters')}
              name="noOfSpecialCharacters"
              rules={[{ required: true, message: VALIDATE_REQUIRED }]}
            >
              <InputNumber className="w-100" />
            </Form.Item>
            <Form.Item
              label={t('accessControlPage_NoOfNumericCharacters')}
              name="noOfNumericCharacters"
              rules={[{ required: true, message: VALIDATE_REQUIRED }]}
            >
              <InputNumber className="w-100" />
            </Form.Item>
            <Form.Item
              label={t('accessControlPage_PasswordExpirationDays')}
              name="passwordExpirationDays"
              rules={[{ required: true, message: VALIDATE_REQUIRED }]}
            >
              <InputNumber className="w-100" />
            </Form.Item>
            <Form.Item name="allowNameCharacters" valuePropName="checked">
              <Checkbox>{t('accessControlPage_AllowNameCharacters')}</Checkbox>
            </Form.Item>
            <Form.Item name="preventPasswordReuse" valuePropName="checked">
              <Checkbox>{t('accessControlPage_PreventPasswordReuse')}</Checkbox>
            </Form.Item>
          </Col>
          <Col md={24}>
            <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
              {t('save')}
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
}
